var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLeftCorner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 259,
    viewBox: "0 0 238 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2532 2.40682C29.1364 9.41032 40.3531 30.445 52.8482 41.0469C76.0294 60.5359 96.2676 54.5467 127.144 55.7301C158.816 56.9134 190.922 57.7345 201.921 91.2789C218.276 141.004 154.787 170.974 179.536 216.859C197.893 250.886 244.448 263.903 237.067 310.32C228.673 363.184 143.957 362.29 106.447 353.476C-23.9799 322.781 -70.1733 161 -36.2821 45.5629C-32.1331 31.3869 -26.3921 16.8968 -14.8619 7.86472C-3.33161 -1.16739 6.07592 -1.57794 14.2532 2.40682Z",
    fill: "#FFBD51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLeftCorner);
export default __webpack_public_path__ + "static/media/login-left-corner.18f886c51943fac09d7aca21cc121614.svg";
export { ForwardRef as ReactComponent };